// extracted by mini-css-extract-plugin
export default {"copyEmail":"InvoiceEmail_copyEmail__HN6Dh","show":"InvoiceEmail_show__bMR7U","warning":"InvoiceEmail_warning__w+jj+"};